import styled from "@emotion/styled";

export const ConfirmationPageWrapper = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	padding: "20px"
});

export const ConfirmationPageHeaderWrapper = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	padding: "24px",
	backgroundColor: theme.project.colors.backgroundColors.main
}));

export const ConfirmationPageHeaderContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "8px"
});

export const ConfirmationPageHeaderTitleContainer = styled.div({
	display: "flex",
	flexDirection: "row",
	gap: "8px",
	justifyContent: "space-between"
});

export const ConfirmationPageHeaderTitle = styled.div(({ theme }) => ({
	...theme.project.typography.heading.h5,
	color: theme.project.colors.fontColors.main
}));

export const ConfirmationPageHeaderSubtitle = styled.div(({ theme }) => ({
	...theme.project.typography.body.body1,
	color: theme.project.colors.fontColors.main
}));

export const ReturnButtonContainer = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "flex-start"
}));
